import { ReactNode } from 'react';

export interface InfoCardProps {
  /** Small label above the title */
  label: string;
  /** Main title text - displayed in focus color */
  title: string;
  /** Optional badge/tag content shown below the title */
  badge?: ReactNode;
  /** Optional className */
  className?: string;
}

/**
 * InfoCard - A small card displaying a label, title, and optional badge
 *
 * Used in side panels to display metric/trigger information in a compact format.
 *
 * @example
 * ```tsx
 * <InfoCard
 *   label="Metric"
 *   title="Temperature"
 *   badge="below 25°"
 * />
 * ```
 */
export function InfoCard({ label, title, badge, className }: InfoCardProps) {
  return (
    <div
      className={`border-border-secondary flex flex-1 flex-col gap-3 rounded-lg
        border p-2 ${className || ''}`}
    >
      <div className='flex flex-col'>
        <span className='size-caption text-secondary'>{label}</span>
        <span className='size-h4 text-focus font-bold'>{title}</span>
      </div>
      {badge && (
        <div
          className='bg-surface-focus-support text-secondary size-caption w-fit
            rounded-xl px-2 py-1'
        >
          {badge}
        </div>
      )}
    </div>
  );
}
